import { Dialog, DialogContent, Typography, Alert, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import uploadIcon from '../images/upload.svg';
import { DeleteRecord } from './deleteRecord';
import Iconify from './Iconify';
import { useRef } from 'react';
import '../css/pdfDocuments.css';

export const UpdatePdfDocuments = ({ openEdit, setOpenEdit, openDeletePDF, setOpenDeletePDF, documents, handleUploadDocuments, handleRemoveAllDocument, handleRemoveDocument, pdfId, setPdfId }) => {

    const { t } = useTranslation();
    const fileInputRef = useRef(null);
    const handleUploadClick = () => fileInputRef.current.click();

    const handleClose = () => {
        setOpenEdit(false);
    }

    return (
        <Dialog open={openEdit} onClose={handleClose} fullWidth maxWidth="lg">
            <Box onClick={handleClose} className='updateDoc_icon_text'>
                <Typography className='updateDoc_title'>{t("Modifier les documents")}</Typography>
                <Iconify icon={"material-symbols:close"} className='updateSiteName_close_icon' />
            </Box>
            <Alert severity="warning" sx={{ width: '100%', marginTop: '10px' }}>{t("Attention, les modifications sont enregistrées automatiquement")}</Alert>
            <DialogContent className='updateDoc_dialog_content'>
                {documents?.length > 0 &&
                    <Iconify className='updateDoc_delete_all_icon' icon={"ic:outline-delete"} onClick={() => setOpenDeletePDF(true)} />
                }
                    <Box
                        onDragOver={(event) => event.preventDefault()} // Prevent default behavior to allow drop
                        onDrop={(event) => {
                            event.preventDefault();
                            handleUploadDocuments(event.dataTransfer.files); // Handle dropped files
                        }}
                        sx={{ width: '100%' }}
                    >
                        <Box className="updateDoc_upload_box" onClick={handleUploadClick}>
                            <img src={uploadIcon} alt="icon" className="updateDoc_upload_icons" loading='lazy' decoding='async' />
                            <Box>
                                <Typography className="updateDoc_uplaod_first_typography">
                                    Glisser-déposez le fichier ici, ou Parcourir
                                </Typography>
                                <Typography className="updateDoc_uplaod_second_typography">
                                    Format PDF de moins de 25Mo
                                </Typography>
                            </Box>
                        </Box>
                        <input
                            type="file"
                            accept=".pdf"
                            ref={fileInputRef}
                            multiple
                            style={{ display: "none" }}
                            onChange={(event) => handleUploadDocuments(event.target.files)}
                        />
                    </Box>
                <Box className='pdfDoc_documents_box'>
                    {documents?.map((doc, index) => (
                        <Box
                            className='pdfDoc_document_item'
                            key={index}
                        >
                            <Iconify className='pdfDoc_pdf_icon' icon={"bxs:file-pdf"} />
                            <Typography className='pdfDoc_doc_name'>{doc?.name}</Typography>
                            <Typography className='pdfDoc_doc_size'>{(doc?.size / (1024 * 1024))?.toFixed(2)} MB</Typography>
                                <Iconify className='pdfDoc_delete_icon' icon={"ic:outline-delete"} onClick={() => { setOpenDeletePDF(true); setPdfId(doc.id) }} />
                        </Box>
                    ))}
                </Box>
                {openDeletePDF &&
                    <DeleteRecord
                        openDelete={openDeletePDF}
                        setOpenDelete={setOpenDeletePDF}
                        title={pdfId ? " Supprimer ce fichier PDF ?" : "Supprimer tous les fichiers PDF ?"}
                        handleDelete={pdfId ? () => handleRemoveDocument(pdfId) : handleRemoveAllDocument}
                    />
                }
            </DialogContent>
        </Dialog>
    );
};